import apiClient from '../client';
import ENDPOINTS from '../endpoints';

function normalizeLink(l) {
  return {
    id: l?._id || l?.id,
    label: l?.name || '',
    url: l?.link || l?.url || '',
    description: l?.description || '',
    dueDate: l?.dueDate ? String(l.dueDate).slice(0, 10) : null,
    isActive: l?.isActive !== false,
  };
}

const linksService = {
  /* Paginated, newest first, scoped to one network (class). */
  list: async (networkId, { page = 1, limit = 10 } = {}) => {
    const res = await apiClient.get(ENDPOINTS.ROOM_PARENT_ADMIN.LINKS_BY_NETWORK(networkId), {
      params: { page, limit },
    });
    const data = res?.data ?? res;
    const rawList =
      data?.links ||
      data?.docs ||
      data?.items ||
      data?.results ||
      (Array.isArray(data?.data) ? data.data : null) ||
      (Array.isArray(data) ? data : []);
    const total = Number(data?.total ?? data?.totalCount ?? data?.count ?? data?.pagination?.total ?? rawList.length);
    const totalPages = Number(
      data?.totalPages ?? data?.pages ?? data?.pagination?.totalPages ?? Math.max(1, Math.ceil(total / limit))
    );
    return { links: rawList.map(normalizeLink), total, totalPages };
  },

  /* dueDate arrives as the form's yyyy-mm-dd — sent as end-of-day ISO. */
  create: ({ networkId, name, link, description, dueDate }) =>
    apiClient.post(ENDPOINTS.ROOM_PARENT_ADMIN.LINK, {
      networkId,
      name,
      link,
      ...(description ? { description } : {}),
      ...(dueDate ? { dueDate: `${dueDate}T23:59:59.000Z` } : {}),
    }),

  /* Status has its own endpoint. description/dueDate are only sent when the
     caller provides them — the redesigned form edits just name + link, and
     omitting the others must not clear what's stored. */
  update: ({ id, name, link, description, dueDate }) =>
    apiClient.put(ENDPOINTS.ROOM_PARENT_ADMIN.LINK, {
      id,
      name,
      link,
      ...(description !== undefined ? { description: description || '' } : {}),
      ...(dueDate !== undefined ? { dueDate: dueDate ? `${dueDate}T23:59:59.000Z` : null } : {}),
    }),

  setStatus: (id, status) => apiClient.patch(ENDPOINTS.ROOM_PARENT_ADMIN.LINK_STATUS, { id, status }),

  /* Hard delete. /roomParentAdmin has no delete for links; the app's own
     group-chat-links route removes the same document and sits behind the same
     auth, so the CMS calls that one. */
  remove: (id) => apiClient.post(ENDPOINTS.GROUP_CHAT_LINKS.DELETE, { id }),
};

export default linksService;
